import axios from "axios";

export function getAllClusterStats() {
  return axios.get("/api/healthStats/getAllclusterStats/");
}
export function getClusterTemplate() {
  return axios.get("/api/healthStats/getClusterTemplate/");
}
